import EmptyConvCheckIcon from "../../icons/conversation-view-check-icon.svg";
import EmptyConvUncheckIcon from "../../icons/conversation-view-uncheck-icon.svg";
import EMptyChat from '../.././icons/EMptyChat.png';
import EmptyConvSelect from '../.././icons/EmptyConvSelect.png';
import { OptionsData } from "../../models/grid.model";
import { ActionLabels } from "../shared/constants";
import { lightBlue } from "@mui/material/colors";
import * as selector from "../../selectors/selectors"
import { useSelector } from "react-redux";
import { ConversationsEmptyLatest, MultiSelectEmpty } from "../../icon";

interface Props {
  ShowMultiActionButtons?: boolean;
  MultiActionButtons?: OptionsData[];
  SelectedConversationsCount?: number;
}

const BlankConvHistory = (props: Props) => {
  const IsDarkMode: boolean = useSelector(selector.isDarkMode);


  return (
    <div className="d-flex w-fill justify-center h-p-100 align-center" >
      <div className="my-auto">
        <div className="d-flex justify-center pb-1">
          {/* <img
            key={props.ShowMultiActionButtons ? "checked" : "unchecked"}
            src={props.ShowMultiActionButtons ? IsDarkMode ? EmptyConvSelect : EmptyConvCheckIcon : IsDarkMode ? EMptyChat : EmptyConvUncheckIcon}
            alt={props.ShowMultiActionButtons ? "Empty conversation checked Icon" : "Empty conversation unchecked Icon"}
          /> */}
          {props.ShowMultiActionButtons ? <MultiSelectEmpty className="w-22 h-22" /> : <ConversationsEmptyLatest className="w-22 h-22" />}
          {/* <ConversationsEmptyLatest className="w-20 h-20"/> */}
          {/* <MultiSelectEmpty className="w-20 h-20"/> */}
        </div>
        {/* <img src={EmptyConvIcon} alt="Empty conversation Icon" /> */}
        <div className=" pt-1 align-center ">
          {!!props.SelectedConversationsCount && <span className="d-flex justify-center color-primary-light h4-medium">{`${props.SelectedConversationsCount} conversations selected`}</span>}
          {props.ShowMultiActionButtons ? (
            <>
              <div className="d-flex justify-between " style={{ gap: '1rem' }}>
                {!!props.MultiActionButtons &&
                  props.MultiActionButtons.map(
                    (btn: OptionsData, index: number) =>
                      !btn.Hide &&
                      btn.Name !==
                      ActionLabels.CLEAR_SELECTION_CONVERSATION && (
                        <button
                          className={`d-flex align-center justify-center grid-btn grid-btn-${btn.Variant}`}
                          key={`${btn.Name}-${index}`}
                          onClick={btn.OnClick}
                          style={{
                            flexGrow: 1,
                            flexBasis: 0,
                          }}
                        >
                          {!!btn.Icon && <btn.Icon className="w-4" />}
                          <span className="h3-regular">{btn.Name}</span>
                        </button>
                      )
                  )}
              </div>
              <hr className="border border-primary border-0 opacity-75 my-3"></hr>
              {props.MultiActionButtons.find(
                (btn) => btn.Name === ActionLabels.CLEAR_SELECTION_CONVERSATION
              ) && (
                  <div className="d-flex justify-center">
                    <button
                      className={`grid-btn grid-btn-${props.MultiActionButtons.find(
                        (btn) => btn.Name === ActionLabels.CLEAR_SELECTION_CONVERSATION
                      ).Variant
                        } ${props.MultiActionButtons.find(
                          (btn) => btn.Name === ActionLabels.CLEAR_SELECTION_CONVERSATION
                        ).ClassName
                        }`}
                      onClick={
                        props.MultiActionButtons.find(
                          (btn) => btn.Name === ActionLabels.CLEAR_SELECTION_CONVERSATION
                        ).OnClick
                      }
                    >
                      {(() => {
                        const clearButton = props.MultiActionButtons.find(
                          (btn) => btn.Name === ActionLabels.CLEAR_SELECTION_CONVERSATION
                        );
                        return clearButton && clearButton.Icon ? (
                          <clearButton.Icon className="w-4" />
                        ) : null;
                      })()}
                      <span className={`h3-regular ${IsDarkMode ? 'color-primary' : ''}`}>
                        {ActionLabels.CLEAR_SELECTION_CONVERSATION}
                      </span>
                    </button>
                  </div>
                )}
            </>
          ) : (
            <span className="t-align-center h4-regular mx-auto color-primary-disabled">
              Click on a Conversation to see messages
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlankConvHistory;
